import React, { useContext, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AppContext from "context/Context";
import { BreadcrumbProvider } from "context/BreadcrumbContext";
import classNames from "classnames";
import NavbarTop from "components/layouts/navbar/top/NavbarTop";
import NavbarVertical from "components/layouts/navbar/vertical/NavbarVertical";
import Footer from "components/layouts/footer/Footer";
import ReleaseNotificationBanner from "components/app/documentation/ReleaseNotificationBanner";
import ImpersonationBanner from "components/common/ImpersonationBanner";
import GlobalRequestErrorOverlay from "components/layouts/errors/GlobalRequestErrorOverlay";
import GlobalAccessDeniedOverlay from "components/layouts/errors/GlobalAccessDeniedOverlay";
import { useDispatch } from "react-redux";
import { getAppSettings } from "redux/appSettingsSlice";
import { isFullBleedPath } from "./fullBleedRoutes";
import "./layout-tw.scss";

const MainLayout = () => {
  const dispatch = useDispatch();
  const { hash, pathname } = useLocation();
  const isFullBleed = isFullBleedPath(pathname);

  const {
    config: { isFluid, navbarPosition }
  } = useContext(AppContext);

  // Always refresh app settings on layout mount so logo/name stay up to date
  useEffect(() => {
    dispatch(getAppSettings());
  }, [dispatch]);

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }
    }, 0);
    // mount-only: honour the hash of the URL the layout was opened with; later hash changes are in-page anchors
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <BreadcrumbProvider>
      {/* Outside the content column and above everything: an administrator must
          not be able to scroll away from the fact that they are working under
          somebody else's name. */}
      <ImpersonationBanner />
      <div className={isFluid ? "ptl-container-fluid" : "ptl-container"}>
        {(navbarPosition === "vertical" || navbarPosition === "combo") && (
          <NavbarVertical />
        )}
        <div
          className={classNames("ptl-content tw-relative", {
            "!tw-pb-0": isFullBleed
          })}
        >
          <NavbarTop />
          <ReleaseNotificationBanner />
          <Outlet />
          {!isFullBleed && <Footer />}
          {/* Request-error prompt — contained to the content column so the sidebar
              and top navbar stay visible/usable below it */}
          <GlobalRequestErrorOverlay contained />
          {/* 403 khi tải dữ liệu của trang → thay nội dung bằng màn hình 403
              thay vì để trang trống + toast */}
          <GlobalAccessDeniedOverlay contained />
        </div>
      </div>
    </BreadcrumbProvider>
  );
};

export default MainLayout;
